import { appendChildren, createEl } from './utils';

export default class Takeoff {
    constructor(state) {
        this.state = state;
        this.el = createEl('div', { className: 'airplane-takeoff' });
        this.video = createEl('video', { className: 'airplane-takeoff-video', src: 'assets/videos/PADCEV_Hangar_Open-Runway_v01.mp4', poster: 'assets/images/PADCEV_Hangar_Open-Runway_v01.png' }, {}, { ended: () => { this.onVideoEnd(); } });

        //this.video = createEl('video', { className: 'airplane-takeoff-video azuremediaplayer amp-default-skin' }, {}, { ended: () => { this.onVideoEnd(); } });
        //this.video.setAttribute('poster', 'assets/images/PADCEV_Hangar_Open-Runway_v01.png');
        //this.video.setAttribute('id', 'vid1');

        //this.video.setAttribute('data-setup', '"nativeControlsForTouch": false');

        //this.video.setAttribute('controls', 'false'); 

      

        //this.source = createEl('source', { src: 'https://astellasuswebotherms.streaming.mediaservices.windows.net/e4c69bc1-07ce-4ce0-abe0-b0a0311dcb81/81-0139-PM_PADCEV_Shortened_MOA_.ism/manifest' });
        //this.source.setAttribute('crossorigin', 'anonymous');
        //this.source.setAttribute('type', 'application/vnd.ms-sstr+xml');
        //this.video.appendChild(this.source);
      
    this.skip = createEl('button', { className: 'airplane-takeoff-skip hidden', innerText: 'SKIP' }, {}, { click: () => { this.skipVideo(); } });


     

        //this.video.appendChild(this.source);
    appendChildren(this.el, this.video, this.skip);
  }

  update(previous, current) {
      if (current === 'takeoff') {

          //var myPlayer = amp('vid1', {
          //    techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
          //    autoplay: false,
          //    controls: false,
          //    muted: true

          //}, function () { });
          //myPlayer.src([{
          //    src: "https://astellasuswebotherms.streaming.mediaservices.windows.net/e4c69bc1-07ce-4ce0-abe0-b0a0311dcb81/81-0139-PM_PADCEV_Shortened_MOA_.ism/manifest&muted=true&playready=true&controls=false",
          //    type: "application/vnd.ms-sstr+xml"
          //}]);
         
          //document.querySelector(".populationCisplatinView").close();
         // myPlayer.play();
          this.video.play();
      this.skip.classList.remove('hidden');
    }
    if (previous === 'takeoff') {
      this.el.classList.add('hidden');
    }
  }

  onVideoEnd() {
    this.state.flow = 'flying';
  }

  skipVideo() {
    this.video.pause();
    this.onVideoEnd();
  }
}
